import { PlatformData } from '../ModuleConfig';

export interface AndroidModuleConfigData extends PlatformData {
  '@type': 'type.googleapis.com/terra.v1.AndroidModuleConfigData';
  initClass: string;
  linkProcessorClass: string;
}

export const AndroidModuleConfigDataFields: (keyof AndroidModuleConfigData)[] = [
  'initClass',
  'linkProcessorClass',
];
